import { TaskType } from '../../graphql/gen/types';
import { useFiltersState } from './useFiltersState';

export function useTasksItemTypeFilter(): TaskType | undefined {
  const [filtersState] = useFiltersState();

  return filtersState.tasks.itemType;
}
